import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const MagePage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.MagePage,
    { fallback: <div></div> },
  )(props);
};
